<form *ngIf="!savedLiability.id" [formGroup]="form" class="flex flex-col">
  <div fxLayout="column" fxLayoutAlign="space-between start">
    <h1 class="header">
      {{ title }}
    </h1>
    <p class="font-medium text-left" style="margin-top: 0; margin-bottom: 2rem">
      {{ subtitle }}
    </p>
  </div>

  <div class="flex justify-start" fxLayoutGap="8px">
    <mat-form-field appearance="outline" class="flex-1 large-spacing" [hideRequiredMarker]="true">
      <mat-label>Dostawca</mat-label>
      <input
        [formControl]="form.biller"
        matInput
        type="text"
        name="biller"
        autocomplete="auto"
        tabindex="0"
        appGtmFormEvent
        [eventField]="'bban'"
        [eventForm]="formName"
        [matAutocomplete]="auto"
        (blur)="onBillerBlur()"
      >
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
          <mat-option *ngFor="let option of filteredOptions | async" [value]="option.name"
                      (onSelectionChange)="setBiller(option)">
              {{ option.name }}
          </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="form.biller">Wpisz dostawcę</mat-error>
    </mat-form-field>
  </div>
  <div *ngIf="showNipControl" class="flexcenter justify-start" fxLayoutGap="8px">
    <mat-form-field appearance="outline" class="flex-1 large-spacing" [hideRequiredMarker]="true">
      <mat-label>Numer NIP</mat-label>

      <input
        [formControl]="form.nip"
        matInput
        type="text"
        name="biller"
        inputmode="numeric"
        mask="000-000-00-00"
        autocomplete="auto"
        tabindex="0"
        appGtmFormEvent
        [eventField]="'nip'"
        [eventForm]="formName"
      >
      <mat-error *ngIf="form.nip.errors">
        <ng-container *ngIf="isNipRequired; else wrongNip">
          Numer NIP jest wymagany
        </ng-container>
        <ng-template #wrongNip>
          Nieprawidłowy numer NIP
        </ng-template>
      </mat-error>

    </mat-form-field>
  </div>
  <mat-form-field appearance="outline" class="large-spacing" [hideRequiredMarker]="true">
    <mat-label>Nr rachunku</mat-label>
    <input
      [formControl]="form.bban"
      matInput
      type="text"
      name="bban"
      mask="00 0000 0000 0000 0000 0000 0000"
      inputmode="numeric"
      autocomplete="off"
      tabindex="0"
      appGtmFormEvent
      [eventField]="'bban'"
      [eventForm]="formName"
    />
    <mat-error *ngIf="form.bban.errors">Nieprawidłowy numer konta</mat-error>
  </mat-form-field>
  <mat-form-field appearance="outline" class="large-spacing" [hideRequiredMarker]="true">
    <mat-label>Kwota rachunku</mat-label>
    <input
      [formControl]="form.amount"
      appCurrency
      matInput
      name="amount"
      type="text"
      autocomplete="off"
      tabindex="0"
      appGtmFormEvent
      [eventField]="'amount'"
      [eventForm]="formName"
    />
        <mat-error>
          <app-amount-error
            [amount]="form.amount"
            [minAmount]="MIN_AMOUNT"
            [maxAmount]="this.appConfig.config.liabilityAmountLimit"
          ></app-amount-error>
        </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="large-spacing" [hideRequiredMarker]="true">
    <mat-label>Tytuł przelewu</mat-label>
    <div class="flex justify-start">
      <input
        matInput
        [formControl]="form.title"
        [maxlength]="this.appConfig.config.titleMaxLength"
        [appInputMaxLength]="this.appConfig.config.titleMaxLength"
        name="title"
        appGtmFormEvent
        [eventField]="'title'"
        [eventForm]="formName"
      />
    </div>
    <mat-hint align="end" style="display: flex; align-items: center">
      <span style=" font-size: 9.5px">
        {{ form.get('title').value?.length || 0 }} / {{ this.appConfig.config.titleMaxLength }}
      </span>
    </mat-hint>
    <mat-error *ngIf="form.title.errors?.required"> Wpisz tytuł</mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="large-spacing" [hideRequiredMarker]="true">
    <mat-label>Data przelewu</mat-label>
    <input
      [formControl]="form.paymentDue"
      matInput
      appInputDateMask
      [matDatepicker]="paymentDue"
      autocomplete="off"
      appGtmFormEvent
      [min]="minDate"
      [max]="maxDate"
      [eventField]="'paymentDue'"
      [eventForm]="formName"
    />
    <mat-datepicker-toggle matSuffix [for]="paymentDue">
      <mat-icon matDatepickerToggleIcon>
        <app-icon name="calendar_today_24"></app-icon>
      </mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker [yPosition]="handsetService.isMobile ?  'above' : null" #paymentDue></mat-datepicker>
    <mat-error *ngIf="form.paymentDue.errors?.matDatepickerMin ||  form.paymentDue.errors?.matDatepickerMax">
      Wybierz datę z zakresu {{ minDate | date: isoPattern }} - {{ maxDate | date: isoPattern}}
    </mat-error>
    <mat-error *ngIf="form.paymentDue.errors?.required"> Wpisz datę przelewu</mat-error>
  </mat-form-field>

  <div class="flex flex-col">
    <app-new-loader-button
      [disabled]="isSubmitted &&  form.invalid"
      [loading]="submitting"
      class="big-button button-250 self-center"
      color="accent"
      style="margin-bottom: 1rem"
      [customType]="LoaderButtonType.RAISED"
      cdkFocusInitial
      [appApiCallLoading]="onSubmit"
      buttonType="submit"
    >
      {{ buttonText ? buttonText : 'Dalej' }}
    </app-new-loader-button>
    <button type="button" mat-button class="self-center font-bold font-medium primary-color " style="width: 250px;"
            (click)="onGoBackClick()">
      Wróć
    </button>
  </div>
</form>

<div *ngIf="savedLiability.id" class="flex flex-col">
  <div fxLayout="column" fxLayoutAlign="space-between center">
    <h1 class="header">
      <ng-container *ngIf="!savedLiability.inVerification">
        Wydatek dodany prawidłowo
      </ng-container>
      <ng-container *ngIf="savedLiability.inVerification">
        Wydatek w weryfikacji
      </ng-container>
    </h1>
    <h2 class="font-medium" style="margin-top: 0; margin-bottom: 0">
      <ng-container *ngIf="!savedLiability.inVerification">
        Możesz teraz odroczyć dodany wydatek.
      </ng-container>
      <ng-container *ngIf="savedLiability.inVerification">
        Musimy zweryfikować dane wskazanego Dostawcy. Nastąpi to najpóźniej następnego dnia roboczego. Dostaniesz powiadomienie, kiedy to nastąpi.
      </ng-container>
    </h2>
    <app-icon *ngIf="!savedLiability.inVerification" name="check_box" [width]="75" [height]="75"
              style="margin: 3rem"></app-icon>
    <app-icon *ngIf="savedLiability.inVerification" name="indeterminate_check_box" [width]="75" [height]="75"
              style="margin: 3rem"></app-icon>
  </div>
  <div class="flex flex-col">
    <app-new-loader-button
      class="big-button button-250 self-center"
      color="accent"
      [customType]="LoaderButtonType.RAISED"
      cdkFocusInitial
      buttonType="submit"
      (buttonClick)="onGoToLiability()"
    >
      Zobacz wydatek
    </app-new-loader-button>
    <button type="button" mat-button class="self-center font-bold font-medium primary-color "
            style="width: 250px;" (click)="onAddNextLiability()">
      Dodaj kolejny
    </button>
  </div>
</div>
